require('es6-promise').polyfill();

import Vue from 'vue'
import App from './App'
import router from './router'
import Updater from "./Updater";
import VueAnalytics from 'vue-analytics'


Vue.config.productionTip = false;

new Updater(60);

Vue.use(VueAnalytics, {
  id: ['UA-117182863-1', 'UA-117115718-1'],
  router
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js